"use strict";

exports.__esModule = true;
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _react = _interopRequireWildcard(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

var _app = require("firebase/app");

var _storage = require("firebase/storage");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LOADING_CHANGED = 'LOADING_CHANGED';
var PROGRESS_CHANGED = 'PROGRESS_CHANGED';
var ERROR = 'ERROR';
var DOWNLOAD_URL_CHANGE = 'DOWNLOAD_URL_CHANGE';
var CLEAR = 'CLEAR';
var CLEAR_ALL = 'CLEAR_ALL';

function reducer(state, action) {
  var _extends2, _extends3, _extends4;

  var type = action.type,
      path = action.path,
      downloadURL = action.downloadURL,
      _action$isUploading = action.isUploading,
      isUploading = _action$isUploading === void 0 ? false : _action$isUploading,
      _action$error = action.error,
      error = _action$error === void 0 ? false : _action$error,
      _action$hasError = action.hasError,
      hasError = _action$hasError === void 0 ? false : _action$hasError,
      _action$progress = action.progress,
      progress = _action$progress === void 0 ? 0 : _action$progress;

  switch (type) {
    case LOADING_CHANGED:
    case PROGRESS_CHANGED:
      return _extends({}, state, (_extends2 = {}, _extends2[path] = _extends({}, state[path], {
        isUploading: isUploading,
        progress: progress
      }), _extends2));

    case ERROR:
      return _extends({}, state, (_extends3 = {}, _extends3[path] = _extends({}, state[path], {
        error: error,
        hasError: hasError,
        isUploading: isUploading,
        progress: progress
      }), _extends3));

    case DOWNLOAD_URL_CHANGE:
      return _extends({}, state, (_extends4 = {}, _extends4[path] = _extends({}, state[path], {
        downloadURL: downloadURL,
        isUploading: isUploading,
        error: error,
        hasError: hasError,
        progress: progress
      }), _extends4));

    case CLEAR:
      var clearedKey = state[path],
          rest = _objectWithoutPropertiesLoose(state, [path].map(_toPropertyKey));

      return _extends({}, rest);

    case CLEAR_ALL:
      return {};

    default:
      throw new Error();
  }
}

var Provider = function Provider(_ref) {
  var children = _ref.children;

  var _useReducer = (0, _react.useReducer)(reducer, {}),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var upload = (0, _react.useCallback)(function (path, uploadTask, onUploaded) {
    dispatch({
      type: LOADING_CHANGED,
      path: path,
      isUploading: true,
      progress: 0
    });
    uploadTask.on('state_changed', function (snapshot) {
      var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      dispatch({
        type: PROGRESS_CHANGED,
        path: path,
        isUploading: true,
        progress: progress
      });
    }, function (error) {
      dispatch({
        type: ERROR,
        path: path,
        isUploading: false,
        error: error,
        hasError: true
      });
    }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var downloadURL;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _storage.getDownloadURL)(uploadTask.snapshot.ref);

            case 2:
              downloadURL = _context.sent;
              dispatch({
                type: DOWNLOAD_URL_CHANGE,
                path: path,
                downloadURL: downloadURL,
                isUploading: false,
                progress: 100
              });

              if (onUploaded) {
                onUploaded(downloadURL, uploadTask.snapshot);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
  }, []);
  var uploadFile = (0, _react.useCallback)(function (alias, path, file, metadata, onUploaded) {
    var uploadTask = (0, _storage.uploadBytesResumable)((0, _storage.ref)((0, _storage.getStorage)((0, _app.getApp)()), path), file, metadata);
    upload(alias, uploadTask, onUploaded);
  }, [upload]);
  var uploadString = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2(alias, path, string, type, metadata, onUploaded) {
      var snap, downloadURL;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch({
                type: LOADING_CHANGED,
                path: path,
                isUploading: true,
                progress: 0
              });
              _context2.next = 3;
              return (0, _storage.uploadString)((0, _storage.ref)((0, _storage.getStorage)((0, _app.getApp)()), path), string, type, metadata);

            case 3:
              snap = _context2.sent;
              _context2.next = 6;
              return (0, _storage.getDownloadURL)(snap.ref);

            case 6:
              downloadURL = _context2.sent;
              dispatch({
                type: DOWNLOAD_URL_CHANGE,
                path: path,
                downloadURL: downloadURL,
                isUploading: false,
                progress: 100
              });

              if (onUploaded) {
                onUploaded(downloadURL, snap);
              }

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2, _x3, _x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  var uploadTask = (0, _react.useCallback)(function (alias, uploadTask, onUploaded) {
    upload(alias, uploadTask, onUploaded);
  }, [upload]);
  var getDownloadURL = (0, _react.useCallback)(function (path) {
    return state[path] ? state[path].downloadURL : false;
  }, [state]);
  var isUploading = (0, _react.useCallback)(function (path) {
    return state[path] ? state[path].isUploading : false;
  }, [state]);
  var getUploadError = (0, _react.useCallback)(function (path) {
    return state[path] ? state[path].error : false;
  }, [state]);
  var hasUploadError = (0, _react.useCallback)(function (path) {
    return state[path] ? state[path].hasError : false;
  }, [state]);
  var getUploadProgress = (0, _react.useCallback)(function (path) {
    return state[path] ? state[path].progress : 0;
  }, [state]);
  var clearUpload = (0, _react.useCallback)(function (path) {
    dispatch({
      type: CLEAR,
      path: path
    });
  }, []);
  var clearAllUploads = (0, _react.useCallback)(function () {
    dispatch({
      type: CLEAR_ALL
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Context.default.Provider, {
    value: {
      uploadFile: uploadFile,
      uploadString: uploadString,
      uploadTask: uploadTask,
      isUploading: isUploading,
      getDownloadURL: getDownloadURL,
      clearUpload: clearUpload,
      clearAllUploads: clearAllUploads,
      hasUploadError: hasUploadError,
      getUploadError: getUploadError,
      getUploadProgress: getUploadProgress
    }
  }, children);
};

var _default = Provider;
exports.default = _default;
module.exports = exports.default;